import styled from 'styled-components';

import { Loader as LoaderLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const ContainerCentered = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 20px;
`;

const Loader = styled(LoaderLayoutComponent)``;

const ErrorMessage = styled(TextLayoutComponent)``;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 30px 100px;
  width: 100%;
`;

const ScreenContainer = styled.div`
  align-items: center;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #EFEFEF;
  display: flex;
  height: 100%;
  justify-content: center;
  margin-top: 10px;
  position: relative;
  padding: 20px;
  width: 100%;
`;

const ScreenRecorderContainer = styled.div`
  border-radius: 5px;
  border: 1px solid #CCCCCC;
  box-shadow: 5px 5px 50px -5px rgba(128,128,128,0.75);
  background: white;
  height: 250px;
  position: absolute;
  right: 20px;
  top: 20px;
  width: 400px;
`;

const Message = styled(TextLayoutComponent)`
  font-size: 20px;
`;

const CenteredMessage = styled(TextLayoutComponent.Title)`
  font-size: 20px;
  text-align: center;
`;

const TextCentered = styled.div`
  margin-top: 75px;
  max-width: 1000px;
  display: flex;
  align-self: ${(props) => (props.hasContext ? 'flex-end' : 'center')};
`;

export {
  CenteredMessage,
  Container,
  ContainerCentered,
  ErrorMessage,
  Loader,
  Message,
  ScreenContainer,
  ScreenRecorderContainer,
  TextCentered,
};
